import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { updatePassword } from "../services/authApi";
import "../../../assets/login_page_assets/css/login.css";
import check from "../../../assets/login_page_assets/images/check.png";
import loginImage from "../../../assets/login_page_assets/images/login.jpg";
import { Button, Form, FormFeedback, Input, Label } from "reactstrap";
import '../../Styles/style.css';
import toast from "react-hot-toast";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";

const ForgetPassword = (props) => {
  const navigate = useNavigate();
  document.title = `Modification de mot de passe | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("L'email est invalide").required("L'email est obligatoire"),
    newPassword: Yup.string()
      .min(8, "Le mot de passe doit contenir au moins 8 caractères")
      .matches(/[A-Z]/, "Le mot de passe doit contenir une majuscule")
      .matches(/[0-9]/, "Le mot de passe doit contenir un chiffre")
      .required("Le nouveau mot de passe est obligatoire"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], "Les mots de passe doivent être identiques")
      .required("Merci de confirmer le nouveau mot de passe"),
  });

  const initialValues = {
    email: "",
    newPassword: "",
    confirmPassword: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await updatePassword({
          email: values.email,
          newPassword: values.newPassword,
        });
        toast.success("Le mot de passe a été modifié avec succès 🎉, Connecte toi à nouveau", {
          duration: 5000,
        });
        formik.resetForm();
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } catch (error) {
        toast.error(`Erreur: ${error?.message || error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="mybox">
      <div className="left-box">
        <div className="left-children">
          <div className="left-logo-box">
            <img src={check} alt="Logo" className="imagelogingauche"/>
          </div>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <Label htmlFor="email" className="text-white">Adresse email</Label>
              <Input
                name="email"
                id="email"
                className="form-control pe-5 login-fc"
                placeholder="Entrer ton adresse email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                invalid={formik.touched.email && formik.errors.email}
              />
              <FormFeedback>{formik.errors.email}</FormFeedback>
            </div>
            <div className="mb-3">
              <Label className="text-white form-label" htmlFor="newPassword">
                Nouveau mot de passe
              </Label>
              <div className="position-relative auth-pass-inputgroup mb-3">
                <Input
                  autoComplete="on"
                  name="newPassword"
                  id="newPassword"
                  value={formik.values.newPassword || ""}
                  type={showNewPassword ? "text" : "password"}
                  className="form-control pe-5 login-fc"
                  placeholder="Entrer le nouveau mot de passe"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.newPassword && formik.errors.newPassword}
                />
                {formik.touched.newPassword && formik.errors.newPassword ? (
                  <FormFeedback>{formik.errors.newPassword}</FormFeedback>
                ) : null}
                <button
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                  type="button"
                  id="password-addon"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  <i className="ri-eye-fill align-middle fs-18"></i>
                </button>
              </div>
            </div>
            <div className="mb-3">
              <Label className="text-white form-label" htmlFor="confirmPassword">
                Confirmer le mot de passe
              </Label>
              <div className="position-relative auth-pass-inputgroup mb-3">
                <Input
                  autoComplete="on"
                  name="confirmPassword"
                  id="confirmPassword"
                  value={formik.values.confirmPassword || ""}
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control pe-5 login-fc"
                  placeholder="Confirmer le nouveau mot de passe"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.confirmPassword && formik.errors.confirmPassword}
                />
                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                  <FormFeedback>{formik.errors.confirmPassword}</FormFeedback>
                ) : null}
                <button
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                  type="button"
                  id="confirm-password-addon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i className="ri-eye-fill align-middle fs-18"></i>
                </button>
              </div>
              <span className="mt-3" style={{ textAlign: "right", cursor: "pointer", color: "#ffffff", textDecoration: "underline" }}
                  title="Réinitialisation de mot de passe"
                  onClick={() => navigate("/login")}
                >
                Retourer à la page de connexion ?
              </span>
            </div>

            <Button
              disabled={isLoading || !formik.isValid || !formik.dirty}
              type="submit"
              className="active-tab form-control btn btn-soft-success pe-5 login-fc"
            >
              {isLoading ? <Spin size="small" /> : "Modifier"}
            </Button>
          </Form>
        </div>
      </div>

      <div className="rigth-box">
        <div className="image-container">
          <div className="text-center">
            <div className="overlay-text">
              <h1 color="#ffffff">Avec Check-auto</h1>
              <h2>La santé de votre véhicule, notre priorité !</h2>
              <h3>Surveillez chaque véhicule pour optimiser ses performances et garantir sa sécurité.</h3>
            </div>
          </div>
          <img src={loginImage} alt="" className="right-img" />
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
